import _ from 'lodash';

const validateAddtlTaxFeesForm = (values) => {
  const errors = [];
  const errorField = values.fees ? 'fees' : 'taxes';

  const valueArrayErrors = [];

  _.map(values.fees || values.taxes, (value, i) => {
    const valueErrors = {};
    if (!value.label) {
      valueErrors.label = true;
    }
    if (!value.amount) {
      valueErrors.amount = true;
    }
    valueArrayErrors[i] = valueErrors;
    errors[errorField] = valueArrayErrors;
  });

  return errors;
};

export default validateAddtlTaxFeesForm;
